// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2J9HJ","avatar":"style_avatar__2aZOa","menuIcon":"style_menuIcon__6GZ9f"};